import { Component } from '@angular/core';

import { ScreenType } from '@fgb/core';

@Component({
  selector: 'fgb-payment-layout',
  templateUrl: './payment-layout.component.html',
  styleUrls: ['./payment-layout.component.scss'],
})
export class PaymentLayoutComponent {
  screenType = ScreenType;
}
